import React from 'react'
import { Grid, Link, List, ListItemIcon, Paper } from '@mui/material'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

import bStrips from '../../media/strips_black.svg'
import wStrips from '../../media/strips_white.svg'

import Point from '../molecules/Point'
import Logo from '../atoms/Logo'

import { ReactComponent as Instagram } from '../../media/instagram.svg'
import { ReactComponent as Facebook } from '../../media/facebook.svg'
import { ReactComponent as LinkedIn } from '../../media/linkedin.svg'
import { ReactComponent as Twitter } from '../../media/twitter.svg'
import { ReactComponent as Youtube } from '../../media/youtube.svg'

import {
	ACTIVITY_REPORT,
	ACTIVITY_REPORT_URL,
	APP_BASE_URL,
	BECOME_VOLUNTEER,
	BECOME_VOLUNTEER_URL,
	HISTORY_URL,
	PARTNER,
	PARTNER_URL,
	PROJECT_URL,
	RECRUITMENT,
	RECRUITMENT_URL,
	REFERENCE_TEAM_URL,
} from '../../constants'

import usePlaces from '../../hooks/usePlaces'

const Footer = ({ whiteStrips }) => {
	const { pathname } = useLocation()
	const hasWhiteStrips =
		whiteStrips ||
		pathname.indexOf(HISTORY_URL) > -1 ||
		pathname.indexOf(REFERENCE_TEAM_URL) > -1 ||
		pathname.indexOf(PROJECT_URL) > -1

	const { isLoading, places } = usePlaces()

	return (
		<Paper
			sx={(theme) => ({
				bgcolor: 'text.secondary',
				borderRadius: 0,
				p: (theme) => theme.spacing(16, 14),
				backgroundImage: `url(${(hasWhiteStrips && wStrips) || bStrips})`,
				backgroundRepeat: 'round no-repeat',

				[theme.breakpoints.down('md')]: {
					p: theme.spacing(10, 3),
					backgroundRepeat: 'no-repeat',
				},
			})}
		>
			<Logo fill="white" />

			<Grid
				container
				spacing={3}
				sx={(theme) => ({
					mt: 0,
					'& .MuiGrid-root:not(:first-of-type)': {
						pt: 5,
					},
					[theme.breakpoints.down('md')]: {
						'& a.MuiTypography-root': {
							borderTop: `1px solid`,
							pt: 3,
							pb: 2,

							'&:first-of-type': {
								border: 'none',
							},
						},
					},
				})}
			>
				<Grid
					item
					xs={12}
					md={3}
					sx={{
						'& a': {
							display: 'block',
							m: (theme) => theme.spacing(2, 0),
							fontSize: 16,
							fontWeight: 700,
							border: 0,
							textDecoration: 'none',

							'&:hover': {
								textDecoration: 'underline',
								cursor: 'pointer',
							},
						},
					}}
				>
					<Link
						sx={{ color: 'white', mt: 0, border: '1px solid white' }}
						href={`${APP_BASE_URL}${ACTIVITY_REPORT_URL}`}
					>
						{ACTIVITY_REPORT}
					</Link>
					<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${PARTNER_URL}`}>
						{PARTNER}
					</Link>
					<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${RECRUITMENT_URL}`}>
						{RECRUITMENT}
					</Link>
					<Link sx={{ color: 'white' }} href={`${APP_BASE_URL}${BECOME_VOLUNTEER_URL}`}>
						{BECOME_VOLUNTEER}
					</Link>
					<Link
						sx={{ color: 'white' }}
						target="_blank"
						href="https://www.helloasso.com/associations/la-collecterie"
					>
						Soutenez-nous{' '}
						<span role="img" aria-label="bravo">
							🙌
						</span>
					</Link>
					<List sx={{ m: (theme) => theme.spacing(3, 0, 2, -0.4), '& a': { m: 0 } }}>
						<ListItemIcon>
							<Link target="_blank" href="https://www.facebook.com/lacollecterie/?fref=ts">
								<Facebook />
							</Link>
						</ListItemIcon>
						<ListItemIcon>
							<Link target="_blank" href="https://www.instagram.com/lacollecterie/">
								<Instagram />
							</Link>
						</ListItemIcon>
						<ListItemIcon>
							<Link target="_blank" href="https://twitter.com/lacollecterie?lang=fr">
								<Twitter />
							</Link>
						</ListItemIcon>
						<ListItemIcon>
							<Link target="_blank" href="https://www.linkedin.com/company/15184655/">
								<LinkedIn />
							</Link>
						</ListItemIcon>
						<ListItemIcon>
							<Link
								target="_blank"
								href="https://www.youtube.com/results?search_query=la+collecterie"
							>
								<Youtube />
							</Link>
						</ListItemIcon>
					</List>
				</Grid>
				{!isLoading &&
					places.map(({ title, street, city, phone, hours }, index) => (
						<Grid item xs={12} md={3} key={index}>
							<Point title={title} street={street} city={city} phone={phone} hours={hours} />
						</Grid>
					))}
			</Grid>
		</Paper>
	)
}

Footer.defaultProps = {
	whiteStrips: false,
}

Footer.propTypes = {
	whiteStrips: PropTypes.bool,
}

export default Footer
